import { createSlice } from '@reduxjs/toolkit';

interface LoaderState {
  isVisible: boolean;
}

const initialState: LoaderState = {
  isVisible: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: state => {
      state.isVisible = true;
    },
    hideLoader: state => {
      state.isVisible = false;
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;